import { render, staticRenderFns } from "./CardReportexUsuarios.vue?vue&type=template&id=4b0c950f&scoped=true"
import script from "./CardReportexUsuarios.vue?vue&type=script&lang=js"
export * from "./CardReportexUsuarios.vue?vue&type=script&lang=js"
import style0 from "./CardReportexUsuarios.vue?vue&type=style&index=0&id=4b0c950f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c950f",
  null
  
)

export default component.exports